import { useState } from "react";
import { supabase } from "@/libs/supabase";
import type { Channel } from "@/types/channel/channel";

interface CreateChannelData {
	name: string;
	description?: string;
	type: Channel["type"];
	emoji?: string;
	isDefault: boolean;
}

export const useCreateChannel = () => {
	const [loading, setLoading] = useState(false);

	const createChannel = async (data: CreateChannelData) => {
		setLoading(true);
		try {
			const { data: channel, error } = await supabase
				.from("channels")
				.insert([
					{
						name: data.name,
						description: data.description,
						type: data.type,
						emoji: data.emoji,
						is_default: data.isDefault,
					},
				])
				.select()
				.single();

			if (error) throw error;
			return channel;
		} finally {
			setLoading(false);
		}
	};

	return { createChannel, loading };
};
